import { View, Text, Link, StyleSheet } from '@react-pdf/renderer';
import { startCase } from 'lodash';

const styles = StyleSheet.create({
  detail: {
    flexDirection: 'row',
    justifyContent: 'start',
  },
});

export const StringField = ({ label, content, vf = false }) =>
  <View style={styles.detail}>
    <Text>{`${startCase(label)}: `}</Text>
    <Text>{vf ? content : startCase(content)}</Text>
  </View>;

export const LinkField = ({ label, content }) => {
  const { src = window.location.href, text } = content;
  return (
    <View style={styles.detail}>
      <Text>{`${startCase(label)}: `}</Text>
      <Link src={src}>{text}</Link>
    </View>
  )
};

export const ValueField = ({ label, content }) => <StringField label={label} content={content} vf={true} />